export const GET_PROFILE ="GET_PROFILE";
export const PROFILE_ERROR ="PROFILE_ERROR";
export const CLEAR_PROFILE ="CLEAR_PROFILE";
export const UPDATE_PROFILE ="UPDATE_PROFILE";

export const DELETE_ACCOUNT ="DELETE_ACCOUNT";

export const GET_PROFILES ="GET_PROFILES";

export const PROFILE_START="PROFILE_START"